import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from "@singularsystems/neo-react";
import { TextConstants } from '../../../Common/TextConstants';
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { AppService, Types } from '../../../App/Services/AppService';
import WACToHoldingsReconciliationReportCriteria from './WACToHoldingsReconciliationReportCriteria';

@NeoReport("WACToHoldingsReconciliation", { category: MaintenanceReportCategories.DataValidationReports })
export default class WAToHoldingsReconciliationReport extends Report<WACToHoldingsReconciliationReportCriteria> {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(WACToHoldingsReconciliationReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={4}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup
                    label={TextConstants.Labels.BrokerAccount}
                    bind={this.criteria.meta.rawAccountNumber} />
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.holdingDate}
                />
            </Neo.GridLayout>
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}